/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePartnerDto,
  CreatePartnerResponseDto,
  CurrencyOptionDto,
  PartnerResponseDto,
  UpdatePartnerDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns every partner. Artic admin only.
 * @summary List all partners
 */
export type partnersAdminControllerListPartnersResponse200 = {
  data: PartnerResponseDto[]
  status: 200
}

export type partnersAdminControllerListPartnersResponse401 = {
  data: void
  status: 401
}

export type partnersAdminControllerListPartnersResponse403 = {
  data: void
  status: 403
}
    
export type partnersAdminControllerListPartnersResponseSuccess = (partnersAdminControllerListPartnersResponse200) & {
  headers: Headers;
};
export type partnersAdminControllerListPartnersResponseError = (partnersAdminControllerListPartnersResponse401 | partnersAdminControllerListPartnersResponse403) & {
  headers: Headers;
};

export type partnersAdminControllerListPartnersResponse = (partnersAdminControllerListPartnersResponseSuccess | partnersAdminControllerListPartnersResponseError)

export const getPartnersAdminControllerListPartnersUrl = () => {


  

  return `/admin/partners`
}

export const partnersAdminControllerListPartners = async ( options?: RequestInit): Promise<partnersAdminControllerListPartnersResponse> => {
  
  return customFetch<partnersAdminControllerListPartnersResponse>(getPartnersAdminControllerListPartnersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPartnersAdminControllerListPartnersQueryKey = () => {
    return [
    `/admin/partners`
    ] as const;
    }

    
export const getPartnersAdminControllerListPartnersQueryOptions = <TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnersAdminControllerListPartnersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>> = ({ signal }) => partnersAdminControllerListPartners({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PartnersAdminControllerListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>>
export type PartnersAdminControllerListPartnersQueryError = void


export function usePartnersAdminControllerListPartners<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnersAdminControllerListPartners>>,
          TError,
          Awaited<ReturnType<typeof partnersAdminControllerListPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListPartners<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnersAdminControllerListPartners>>,
          TError,
          Awaited<ReturnType<typeof partnersAdminControllerListPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListPartners<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all partners
 */

export function usePartnersAdminControllerListPartners<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPartnersAdminControllerListPartnersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List all partners
 */
export const prefetchPartnersAdminControllerListPartnersQuery = async <TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getPartnersAdminControllerListPartnersQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getPartnersAdminControllerListPartnersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnersAdminControllerListPartnersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>> = ({ signal }) => partnersAdminControllerListPartners({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PartnersAdminControllerListPartnersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>>
export type PartnersAdminControllerListPartnersSuspenseQueryError = void


export function usePartnersAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all partners
 */

export function usePartnersAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPartnersAdminControllerListPartnersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a partner and, in the same transaction, links every Artic staff profile (email on artic.works / trunk.works) via partners_profiles so the new partner appears in their partner switcher immediately. Artic admin only.
 * @summary Create a partner and auto-link all Artic staff
 */
export type partnersAdminControllerCreatePartnerResponse201 = {
  data: CreatePartnerResponseDto
  status: 201
}

export type partnersAdminControllerCreatePartnerResponse401 = {
  data: void
  status: 401
}

export type partnersAdminControllerCreatePartnerResponse403 = {
  data: void
  status: 403
}

export type partnersAdminControllerCreatePartnerResponse409 = {
  data: void
  status: 409
}
    
export type partnersAdminControllerCreatePartnerResponseSuccess = (partnersAdminControllerCreatePartnerResponse201) & {
  headers: Headers;
};
export type partnersAdminControllerCreatePartnerResponseError = (partnersAdminControllerCreatePartnerResponse401 | partnersAdminControllerCreatePartnerResponse403 | partnersAdminControllerCreatePartnerResponse409) & {
  headers: Headers;
};

export type partnersAdminControllerCreatePartnerResponse = (partnersAdminControllerCreatePartnerResponseSuccess | partnersAdminControllerCreatePartnerResponseError)

export const getPartnersAdminControllerCreatePartnerUrl = () => {


  

  return `/admin/partners`
}

export const partnersAdminControllerCreatePartner = async (createPartnerDto: CreatePartnerDto, options?: RequestInit): Promise<partnersAdminControllerCreatePartnerResponse> => {
  
  return customFetch<partnersAdminControllerCreatePartnerResponse>(getPartnersAdminControllerCreatePartnerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPartnerDto,)
  }
);}




export const getPartnersAdminControllerCreatePartnerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnersAdminControllerCreatePartner>>, TError,{data: CreatePartnerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof partnersAdminControllerCreatePartner>>, TError,{data: CreatePartnerDto}, TContext> => {

const mutationKey = ['partnersAdminControllerCreatePartner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof partnersAdminControllerCreatePartner>>, {data: CreatePartnerDto}> = (props) => {
          const {data} = props ?? {};

          return  partnersAdminControllerCreatePartner(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PartnersAdminControllerCreatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerCreatePartner>>>
    export type PartnersAdminControllerCreatePartnerMutationBody = CreatePartnerDto
    export type PartnersAdminControllerCreatePartnerMutationError = void

    /**
 * @summary Create a partner and auto-link all Artic staff
 */
export const usePartnersAdminControllerCreatePartner = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnersAdminControllerCreatePartner>>, TError,{data: CreatePartnerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof partnersAdminControllerCreatePartner>>,
        TError,
        {data: CreatePartnerDto},
        TContext
      > => {

      const mutationOptions = getPartnersAdminControllerCreatePartnerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The currencies a partner_currency may reference (ENG-871 Operating Costs). Artic admin only.
 * @summary Display-currency options for the partner form
 */
export type partnersAdminControllerListCurrencyOptionsResponse200 = {
  data: CurrencyOptionDto[]
  status: 200
}

export type partnersAdminControllerListCurrencyOptionsResponse401 = {
  data: void
  status: 401
}

export type partnersAdminControllerListCurrencyOptionsResponse403 = {
  data: void
  status: 403
}
    
export type partnersAdminControllerListCurrencyOptionsResponseSuccess = (partnersAdminControllerListCurrencyOptionsResponse200) & {
  headers: Headers;
};
export type partnersAdminControllerListCurrencyOptionsResponseError = (partnersAdminControllerListCurrencyOptionsResponse401 | partnersAdminControllerListCurrencyOptionsResponse403) & {
  headers: Headers;
};

export type partnersAdminControllerListCurrencyOptionsResponse = (partnersAdminControllerListCurrencyOptionsResponseSuccess | partnersAdminControllerListCurrencyOptionsResponseError)

export const getPartnersAdminControllerListCurrencyOptionsUrl = () => {


  

  return `/admin/partners/currency-options`
}

export const partnersAdminControllerListCurrencyOptions = async ( options?: RequestInit): Promise<partnersAdminControllerListCurrencyOptionsResponse> => {
  
  return customFetch<partnersAdminControllerListCurrencyOptionsResponse>(getPartnersAdminControllerListCurrencyOptionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPartnersAdminControllerListCurrencyOptionsQueryKey = () => {
    return [
    `/admin/partners/currency-options`
    ] as const;
    }

    
export const getPartnersAdminControllerListCurrencyOptionsQueryOptions = <TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnersAdminControllerListCurrencyOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>> = ({ signal }) => partnersAdminControllerListCurrencyOptions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PartnersAdminControllerListCurrencyOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>>
export type PartnersAdminControllerListCurrencyOptionsQueryError = void


export function usePartnersAdminControllerListCurrencyOptions<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>,
          TError,
          Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListCurrencyOptions<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>,
          TError,
          Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListCurrencyOptions<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Display-currency options for the partner form
 */

export function usePartnersAdminControllerListCurrencyOptions<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPartnersAdminControllerListCurrencyOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Display-currency options for the partner form
 */
export const prefetchPartnersAdminControllerListCurrencyOptionsQuery = async <TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getPartnersAdminControllerListCurrencyOptionsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getPartnersAdminControllerListCurrencyOptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnersAdminControllerListCurrencyOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>> = ({ signal }) => partnersAdminControllerListCurrencyOptions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PartnersAdminControllerListCurrencyOptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>>
export type PartnersAdminControllerListCurrencyOptionsSuspenseQueryError = void


export function usePartnersAdminControllerListCurrencyOptionsSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListCurrencyOptionsSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerListCurrencyOptionsSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Display-currency options for the partner form
 */

export function usePartnersAdminControllerListCurrencyOptionsSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError = void>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerListCurrencyOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPartnersAdminControllerListCurrencyOptionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Artic admin only.
 * @summary Get a partner by id
 */
export type partnersAdminControllerGetPartnerResponse200 = {
  data: PartnerResponseDto
  status: 200
}

export type partnersAdminControllerGetPartnerResponse401 = {
  data: void
  status: 401
}

export type partnersAdminControllerGetPartnerResponse403 = {
  data: void
  status: 403
}

export type partnersAdminControllerGetPartnerResponse404 = {
  data: void
  status: 404
}
    
export type partnersAdminControllerGetPartnerResponseSuccess = (partnersAdminControllerGetPartnerResponse200) & {
  headers: Headers;
};
export type partnersAdminControllerGetPartnerResponseError = (partnersAdminControllerGetPartnerResponse401 | partnersAdminControllerGetPartnerResponse403 | partnersAdminControllerGetPartnerResponse404) & {
  headers: Headers;
};

export type partnersAdminControllerGetPartnerResponse = (partnersAdminControllerGetPartnerResponseSuccess | partnersAdminControllerGetPartnerResponseError)

export const getPartnersAdminControllerGetPartnerUrl = (partnerId: string,) => {


  

  return `/admin/partners/${partnerId}`
}

export const partnersAdminControllerGetPartner = async (partnerId: string, options?: RequestInit): Promise<partnersAdminControllerGetPartnerResponse> => {
  
  return customFetch<partnersAdminControllerGetPartnerResponse>(getPartnersAdminControllerGetPartnerUrl(partnerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPartnersAdminControllerGetPartnerQueryKey = (partnerId?: string,) => {
    return [
    `/admin/partners/${partnerId}`
    ] as const;
    }

    
export const getPartnersAdminControllerGetPartnerQueryOptions = <TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnersAdminControllerGetPartnerQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>> = ({ signal }) => partnersAdminControllerGetPartner(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PartnersAdminControllerGetPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>>
export type PartnersAdminControllerGetPartnerQueryError = void


export function usePartnersAdminControllerGetPartner<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>,
          TError,
          Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerGetPartner<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>,
          TError,
          Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerGetPartner<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a partner by id
 */

export function usePartnersAdminControllerGetPartner<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPartnersAdminControllerGetPartnerQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a partner by id
 */
export const prefetchPartnersAdminControllerGetPartnerQuery = async <TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getPartnersAdminControllerGetPartnerQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getPartnersAdminControllerGetPartnerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnersAdminControllerGetPartnerQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>> = ({ signal }) => partnersAdminControllerGetPartner(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PartnersAdminControllerGetPartnerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>>
export type PartnersAdminControllerGetPartnerSuspenseQueryError = void


export function usePartnersAdminControllerGetPartnerSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerGetPartnerSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePartnersAdminControllerGetPartnerSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a partner by id
 */

export function usePartnersAdminControllerGetPartnerSuspense<TData = Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof partnersAdminControllerGetPartner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPartnersAdminControllerGetPartnerSuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates display name, domain, settings (shallow-merged) and/or work-order level keys. Artic admin only.
 * @summary Update a partner
 */
export type partnersAdminControllerUpdatePartnerResponse200 = {
  data: PartnerResponseDto
  status: 200
}

export type partnersAdminControllerUpdatePartnerResponse401 = {
  data: void
  status: 401
}

export type partnersAdminControllerUpdatePartnerResponse403 = {
  data: void
  status: 403
}

export type partnersAdminControllerUpdatePartnerResponse404 = {
  data: void
  status: 404
}
    
export type partnersAdminControllerUpdatePartnerResponseSuccess = (partnersAdminControllerUpdatePartnerResponse200) & {
  headers: Headers;
};
export type partnersAdminControllerUpdatePartnerResponseError = (partnersAdminControllerUpdatePartnerResponse401 | partnersAdminControllerUpdatePartnerResponse403 | partnersAdminControllerUpdatePartnerResponse404) & {
  headers: Headers;
};

export type partnersAdminControllerUpdatePartnerResponse = (partnersAdminControllerUpdatePartnerResponseSuccess | partnersAdminControllerUpdatePartnerResponseError)

export const getPartnersAdminControllerUpdatePartnerUrl = (partnerId: string,) => {


  

  return `/admin/partners/${partnerId}`
}

export const partnersAdminControllerUpdatePartner = async (partnerId: string,
    updatePartnerDto: UpdatePartnerDto, options?: RequestInit): Promise<partnersAdminControllerUpdatePartnerResponse> => {
  
  return customFetch<partnersAdminControllerUpdatePartnerResponse>(getPartnersAdminControllerUpdatePartnerUrl(partnerId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePartnerDto,)
  }
);}




export const getPartnersAdminControllerUpdatePartnerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnersAdminControllerUpdatePartner>>, TError,{partnerId: string;data: UpdatePartnerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof partnersAdminControllerUpdatePartner>>, TError,{partnerId: string;data: UpdatePartnerDto}, TContext> => {

const mutationKey = ['partnersAdminControllerUpdatePartner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof partnersAdminControllerUpdatePartner>>, {partnerId: string;data: UpdatePartnerDto}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  partnersAdminControllerUpdatePartner(partnerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PartnersAdminControllerUpdatePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof partnersAdminControllerUpdatePartner>>>
    export type PartnersAdminControllerUpdatePartnerMutationBody = UpdatePartnerDto
    export type PartnersAdminControllerUpdatePartnerMutationError = void

    /**
 * @summary Update a partner
 */
export const usePartnersAdminControllerUpdatePartner = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnersAdminControllerUpdatePartner>>, TError,{partnerId: string;data: UpdatePartnerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof partnersAdminControllerUpdatePartner>>,
        TError,
        {partnerId: string;data: UpdatePartnerDto},
        TContext
      > => {

      const mutationOptions = getPartnersAdminControllerUpdatePartnerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    